export { default } from './WordCloud';
